const ajaxFunctions = () => {
    // Rooms & Suites
    filterRoomsSuites();

    // Galleries
    loadMoreGalleryItems();
    filterGalleryItems();

    // What's On Posts
    loadMoreWhatsOnPosts();
    filterWhatsOnPosts();

    // Local Area Guide Items
    loadMoreLagItems();
    filterLagItems();

    // Menus
    // Filter Menu Type
    $(document).on('click', '.js-menu-type-filter:not(.active)', function(e) {
        const locationID = $(this).data('location-id');
        const menuType = $(this).data('menu-type');

        $('.menus__filter-item').removeClass('active');
        $(this).addClass('active');

        filterMenuType(locationID, menuType);
    });
    // Filter Menus
    $(document).on('click', '.js-menu-filter:not(.active)', function(e) {
        const menuID = $(this).data('menu-id');

        $('.menus__menu').removeClass('active');
        $(this).addClass('active');

        filterMenus(menuID);
    });
    $(document).on('change', '.js-menu-select-filter', function(e) {
        e.preventDefault();

        const menuID = $(this).find(':selected').val();

        filterMenus(menuID);
    });
    // Filter Menu Items
    $(document).on('click', '.js-menu-section-filter:not(.active)', function(e) {
        e.preventDefault();

        const menuID = $(this).data('menu-id');
        const menuSectionIndex = $(this).data('menu-section-index');

        $('.menus__menu-section').removeClass('active');
        $(this).addClass('active');

        filterMenuItems(menuID, menuSectionIndex);
    });
    $(document).on('change', '.js-menu-section-select-filter', function(e) {
        e.preventDefault();

        const menuID = $(this).find(':selected').val();
        const menuSectionIndex = $(this).find(':selected').data('menu-section-index');

        filterMenuItems(menuID, menuSectionIndex);
    });
}

const filterRoomsSuites = () => {
    $(document).on('click', '.js-rooms-suite-filter:not(.active)', function(e) {
        const contentContainer = $('.js-rooms-suites-posts-container');
        const roomType = $(this).data('room-type');

        $('.rooms-suites__filter-item').removeClass('active');
        $(this).addClass('active');

        // Set min height for the content
        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        gsap.to(contentContainer, { 
            autoAlpha: 0, duration: 0.4,
            onComplete: () => {
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: main__js_vars.ajaxurl,
                    data: {
                        'room_type': roomType,
                        'action': 'ajax_toggle_room_type'
                    },
                    success: function (data) {
                        const returnedData = JSON.parse(data);
                        
                        contentContainer.html( returnedData.posts );

                        roomsSuitesSliderInits();
                        
                        gsap.to(contentContainer, { 
                            autoAlpha: 1, duration: 0.4,
                            onComplete: () => {
                                contentContainer.removeAttr('style');

                                contentContainer.find('.js-hidden').addClass('js-visible');
                                
                                ScrollTrigger.refresh();
                            }
                        });
                    },
                    error : function (jqXHR, textStatus, errorThrown) {
                        $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                        console.log(jqXHR);
                    },
                });
            }
        });
    });    
}

const loadMoreGalleryItems = () => {
    $(document).on('click', '.js-load-more-gallery-items', function(e) {
        e.preventDefault();

        const btn = $(this);

        const contentContainer = $('.js-galleries-container');
        const galleryID = $('.galleries__filter-item.active').data('gallery-id');
        const offset = $('.galleries__item').length;

        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        btn.find('.c-btn__text').text('Loading...');
        btn.addClass('loading');

        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: main__js_vars.ajaxurl,
            data: {
                'gallery_id': galleryID,
                'offset': offset,
                'action': 'ajax_load_more_gallery_items'
            },
            success: function (data) {
                const returnedData = JSON.parse(data);
                
                contentContainer.append( returnedData.items );

                if ( $('.galleries__item').length == returnedData.itemsCount ) {
                    $('.galleries__load-more-container').hide();
                }

                btn.find('.c-btn__text').text('Load more');
                btn.removeClass('loading');
                
                contentContainer.removeAttr('style');

                contentContainer.find('.js-hidden').addClass('js-visible');
            },
            error : function (jqXHR, textStatus, errorThrown) {
                $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                console.log(jqXHR);
            },
        });      
    });
}

const filterGalleryItems = () => {
    $(document).on('click', '.galleries__filter-item:not(.active)', function(e) {
        const contentContainer = $('.js-galleries-container');
        const galleryID = $(this).data('gallery-id');

        $('.galleries__filter-item').removeClass('active');
        $(this).addClass('active');

        // Set min height for the content
        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        gsap.to(contentContainer, { 
            autoAlpha: 0, duration: 0.4,
            onComplete: () => {
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: main__js_vars.ajaxurl,
                    data: {
                        'gallery_id': galleryID,
                        'action': 'ajax_change_gallery_items'
                    },
                    success: function (data) {
                        const returnedData = JSON.parse(data);
                        
                        contentContainer.html( returnedData.items );

                        if ( returnedData.itemsCount <= 8 ) {
                            $('.galleries__load-more-container').hide();
                        } else {
                            $('.galleries__load-more-container').show();
                            $('.galleries__load-more-container .c-btn').removeClass('loading');
                            $('.galleries__load-more-container .c-btn .c-btn__text').text('Load more');
                        }
                        
                        gsap.to(contentContainer, { 
                            autoAlpha: 1, duration: 0.4,
                            onComplete: () => {
                                contentContainer.removeAttr('style');

                                contentContainer.find('.js-hidden').addClass('js-visible');
                            }
                        });
                    },
                    error : function (jqXHR, textStatus, errorThrown) {
                        $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                        console.log(jqXHR);
                    },
                });
            }
        });
    }); 
}

const loadMoreWhatsOnPosts = () => {
    $(document).on('click', '.js-load-more-whats-on-posts', function(e) {
        e.preventDefault();

        const btn = $(this);

        const contentContainer = $('.js-whats-on-posts-container');
        const filter = $('.whats-on .c-filter__dropdown').find(':selected').val();
        const offset = $('.whats-on .grid-items__item').length;

        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        btn.find('.c-btn__text').text('Loading...');
        btn.addClass('loading');

        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: main__js_vars.ajaxurl,
            data: {
                'filter': filter,
                'offset': offset,
                'action': 'ajax_load_more_whats_on_posts'
            },
            success: function (data) {
                const returnedData = JSON.parse(data);
                
                contentContainer.append( returnedData.items );

                if ( $('.whats-on .grid-items__item').length == returnedData.itemsCount ) {
                    $('.whats-on__load-more-container').hide();
                }

                btn.find('.c-btn__text').text('Load more');
                btn.removeClass('loading');
                
                contentContainer.removeAttr('style');

                contentContainer.find('.js-hidden').addClass('js-visible');
            },
            error : function (jqXHR, textStatus, errorThrown) {
                $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                console.log(jqXHR);
            },
        });      
    });
}

const filterWhatsOnPosts = () => {
    $(document).on('change', '.whats-on .c-filter__dropdown', function(e) {
        const contentContainer = $('.js-whats-on-posts-container');
        const filter = $(this).find(':selected').val();

        // Set min height for the content
        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        gsap.to(contentContainer, { 
            autoAlpha: 0, duration: 0.4,
            onComplete: () => {
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: main__js_vars.ajaxurl,
                    data: {
                        'filter': filter,
                        'action': 'ajax_filter_whats_on_posts'
                    },
                    success: function (data) {
                        const returnedData = JSON.parse(data);
                        
                        contentContainer.html( returnedData.items );

                        if ( returnedData.itemsCount <= 8 ) {
                            $('.whats-on__load-more-container').hide();
                        } else {
                            $('.whats-on__load-more-container').show();
                            $('.whats-on__load-more-container .c-btn').removeClass('loading');
                            $('.whats-on__load-more-container .c-btn .c-btn__text').text('Load more');
                        }
                        
                        gsap.to(contentContainer, { 
                            autoAlpha: 1, duration: 0.4,
                            onComplete: () => {
                                contentContainer.removeAttr('style');
                                contentContainer.find('.js-hidden').addClass('js-visible');
                            }
                        });
                    },
                    error : function (jqXHR, textStatus, errorThrown) {
                        $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                        console.log(jqXHR);
                    },
                });
            }
        });
    }); 
}

const loadMoreLagItems = () => {
    $(document).on('click', '.js-load-more-lag-items', function(e) {
        e.preventDefault();

        const btn = $(this);

        const contentContainer = $('.js-lag-items-container');
        const filter = $('.lag .c-filter__dropdown').find(':selected').val();
        const offset = $('.lag .grid-items__item').length;

        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        btn.find('.c-btn__text').text('Loading...');
        btn.addClass('loading');

        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: main__js_vars.ajaxurl,
            data: {
                'filter': filter,
                'offset': offset,
                'action': 'ajax_load_more_lag_items'
            },
            success: function (data) {
                const returnedData = JSON.parse(data);
                
                contentContainer.append( returnedData.items );


                if ( $('.lag .grid-items__item').length == returnedData.itemsCount ) {
                    $('.lag__load-more-container').hide();
                }

                btn.find('.c-btn__text').text('Load more');
                btn.removeClass('loading');
                
                contentContainer.removeAttr('style');

                contentContainer.find('.js-hidden').addClass('js-visible');
            },
            error : function (jqXHR, textStatus, errorThrown) {
                $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                console.log(jqXHR);
            },
        });      
    });
}

const filterLagItems = () => {
    $(document).on('change', '.lag .c-filter__dropdown', function(e) {
        const contentContainer = $('.js-lag-items-container');
        const filter = $(this).find(':selected').val();

        // Set min height for the content
        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        gsap.to(contentContainer, { 
            autoAlpha: 0, duration: 0.4,
            onComplete: () => {
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: main__js_vars.ajaxurl,
                    data: {
                        'filter': filter,
                        'action': 'ajax_filter_lag_items'
                    },
                    success: function (data) {
                        const returnedData = JSON.parse(data);
                        
                        contentContainer.html( returnedData.items );

                        if ( returnedData.itemsCount <= 9 ) {
                            $('.lag__load-more-container').hide();
                        } else {
                            $('.lag__load-more-container').show();
                            $('.lag__load-more-container .c-btn').removeClass('loading');
                            $('.lag__load-more-container .c-btn .c-btn__text').text('Load more');
                        }
                        
                        gsap.to(contentContainer, { 
                            autoAlpha: 1, duration: 0.4,
                            onComplete: () => {
                                contentContainer.removeAttr('style');
                                contentContainer.find('.js-hidden').addClass('js-visible');
                            }
                        });
                    },
                    error : function (jqXHR, textStatus, errorThrown) {
                        $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                        console.log(jqXHR);
                    },
                });
            }
        });
    }); 
}

const filterMenuType = (locationID, menuType) => {
    const menusFilterContainer = $('.js-menus-container');
    const filterContainer = $('.js-menu-section-filter-container');
    const contentContainer = $('.js-menu-items-container');

    const menusFilterMinHeight = filterContainer.outerHeight();
    const filterMinHeight = filterContainer.outerHeight();
    const contentMinHeight = contentContainer.outerHeight();

    contentContainer.css('min-height', contentMinHeight+'px');
    filterContainer.css('min-height', filterMinHeight+'px');
    menusFilterContainer.css('min-height', menusFilterMinHeight+'px');

    const fadeElems = [contentContainer, $('.js-menu-fade-elem')];

    gsap.to(fadeElems, { 
        autoAlpha: 0, duration: 0.4,
        onComplete: () => {
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: main__js_vars.ajaxurl,
                data: {
                    'location_id': locationID,
                    'menu_type': menuType,
                    'action': 'ajax_filter_menu_types'
                },
                success: function (data) {
                    const returnedData = JSON.parse(data);
                    
                    menusFilterContainer.html( returnedData.menus );
                    filterContainer.html( returnedData.menu_sections );
                    contentContainer.html( returnedData.menu_items );
                    
                    gsap.to(fadeElems, { 
                        autoAlpha: 1, duration: 0.4,
                        onComplete: () => {
                            menusFilterContainer.removeAttr('style');
                            filterContainer.removeAttr('style');
                            contentContainer.removeAttr('style');

                            menusFilterContainer.find('.js-hidden').addClass('js-visible');
                            filterContainer.find('.js-hidden').addClass('js-visible');
                            contentContainer.find('.js-hidden').addClass('js-visible');
                            
                            ScrollTrigger.refresh();
                        }
                    });
                },
                error : function (jqXHR, textStatus, errorThrown) {
                    $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                    console.log(jqXHR);
                },
            });
        }
    });    
}

const filterMenus = (menuID) => {
    const filterContainer = $('.js-menu-section-filter-container');
    const contentContainer = $('.js-menu-items-container');

    const filterMinHeight = filterContainer.outerHeight();
    const contentMinHeight = contentContainer.outerHeight();

    contentContainer.css('min-height', contentMinHeight+'px');
    filterContainer.css('min-height', filterMinHeight+'px');

    const fadeElems = [contentContainer, '.js-menu-fade-elem:not(.js-menu-select-filter):not(.js-menu-filter)'];

    gsap.to(fadeElems, { 
        autoAlpha: 0, duration: 0.4,
        onComplete: () => {
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: main__js_vars.ajaxurl,
                data: {
                    'menu_id': menuID,
                    'action': 'ajax_filter_menus'
                },
                success: function (data) {
                    const returnedData = JSON.parse(data);
                    
                    filterContainer.html( returnedData.menu_sections );
                    contentContainer.html( returnedData.menu_items );
                    
                    gsap.to(fadeElems, { 
                        autoAlpha: 1, duration: 0.4,
                        onComplete: () => {
                            filterContainer.removeAttr('style');
                            contentContainer.removeAttr('style');

                            filterContainer.find('.js-hidden').addClass('js-visible');
                            contentContainer.find('.js-hidden').addClass('js-visible');

                            ScrollTrigger.refresh();
                        }
                    });
                },
                error : function (jqXHR, textStatus, errorThrown) {
                    $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                    console.log(jqXHR);
                },
            });
        }
    });    
}

const filterMenuItems = (menuID, menuSectionIndex) => {
    const contentContainer = $('.js-menu-items-container');
    const minHeight = contentContainer.outerHeight();
    contentContainer.css('min-height', minHeight+'px');

    gsap.to(contentContainer, { 
        autoAlpha: 0, duration: 0.4,
        onComplete: () => {
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: main__js_vars.ajaxurl,
                data: {
                    'menu_id': menuID,
                    'menu_section_index': menuSectionIndex,
                    'action': 'ajax_filter_menu_items'
                },
                success: function (data) {
                    const returnedData = JSON.parse(data);
                    
                    contentContainer.html( returnedData.menu_items );
                    
                    gsap.to(contentContainer, { 
                        autoAlpha: 1, duration: 0.4,
                        onComplete: () => {
                            contentContainer.removeAttr('style');

                            contentContainer.find('.js-hidden').addClass('js-visible');

                            ScrollTrigger.refresh();
                        }
                    });
                },
                error : function (jqXHR, textStatus, errorThrown) {
                    $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                    console.log(jqXHR);
                },
            });
        }
    });    
}